export enum SessionType {
  PayOnInvoice = 'PayOnInvoice',
  PayOtherAmount = 'PayOtherAmount',
  PayOnAccount = 'PayOnAccount',
  HostedPaymentsPage = 'HostedPaymentsPage',
}
